"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkListenerService = void 0;
const listenerToken_1 = require("../support/listenerToken");
class ChunkListenerService {
    constructor() {
        this.registry = new Map();
        this.tokenToChunk = new Map();
    }
    async registerListener(chunkPos, callback) {
        const registrationToken = await listenerToken_1.generateListenerToken();
        this.tokenToChunk.set(registrationToken, chunkPos);
        if (this.registry.has(chunkPos.asMapKey())) {
            this.registry.get(chunkPos.asMapKey()).set(registrationToken, callback);
        }
        else {
            const innerMap = new Map();
            innerMap.set(registrationToken, callback);
            this.registry.set(chunkPos.asMapKey(), innerMap);
        }
        this.printListenerStats();
        return registrationToken;
    }
    unregisterListener(token) {
        if (!this.tokenToChunk.has(token)) {
            return;
        }
        const chunkPos = this.tokenToChunk.get(token);
        if (this.registry.has(chunkPos.asMapKey())) {
            this.registry.get(chunkPos.asMapKey()).delete(token);
        }
        this.tokenToChunk.delete(token);
        this.printListenerStats();
    }
    onChunkUpdate(chunkUpdate) {
        if (!this.registry.has(chunkUpdate.chunk.asMapKey())) {
            return;
        }
        this.registry.get(chunkUpdate.chunk.asMapKey())
            .forEach(cb => {
            setTimeout(() => cb(chunkUpdate), 0);
        });
    }
    printListenerStats() {
        let count = 0;
        for (let [_, chunk] of this.registry.entries()) {
            count += chunk.size;
        }
        console.log('listener stats', count);
    }
}
exports.ChunkListenerService = ChunkListenerService;
//# sourceMappingURL=ChunkListenerService.js.map